import React, { useState, useMemo, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import UserContext from '../../../../common/utils/getContext';
import NoReferal from './NoReferal/NoReferal';
import InputSponsor from '../form-input/FormInput/FormInput';
import { useWidgetTranslates } from '../../../../common/utils/utils';
import { t } from '../../../../common/components/T';

const FormSponsorWidget = (props) => {
    const { attribute, switchHint, disabled, title, value, setFormData, variation } = props;
    const [inp, setInp] = useState({ val: value || null, showInput: true });
    const { refer } = useContext(UserContext);
    const transl = useWidgetTranslates('form');
    const refData = useMemo(() => {
        if (refer && refer !== 'false') return refer;
        return false;
    }, [refer]);
    useEffect(() => {
        if (refData) setFormData(attribute, refData);
    }, [attribute, refData, setFormData]);
    return (
        <div>
            {!refData && (
                <NoReferal
                    switchHint={switchHint}
                    inp={inp}
                    setInp={setInp}
                    title={title}
                    disabled={disabled}
                    setFormData={setFormData}
                    attribute={attribute}
                    translation={transl}
                />
            )}
            <div>
                {!!inp.showInput && (
                    <InputSponsor
                        {...props}
                        value={value || refData}
                        disabled={Boolean(disabled) || !!refData}
                        title={
                            title || variation !== 'no_title'
                                ? {
                                      body: t('FormSponsorWidget-placeholder', 'Логин спонсора', 'widget', transl, 'form')
                                  }
                                : false
                        }
                    />
                )}
            </div>
        </div>
    );
};
FormSponsorWidget.propTypes = {
    attribute: PropTypes.string,
    switchHint: PropTypes.node,
    disabled: PropTypes.bool,
    title: PropTypes.object,
    value: PropTypes.string,
    setFormData: PropTypes.func,
    variation: PropTypes.string
};
export default FormSponsorWidget;
